import type { ReactNode } from "react";
import { Card } from "./beui/SurfaceCard";
import "./WorkLayout.css";

/** Approved A presentation. Adapters retain admission, commands and record/profile lifetime. */
export function WorkLayout({ checklist, history, children }: { checklist: ReactNode; history: ReactNode; children: ReactNode }) {
  return <div className="work-updates wu-layout-a">
    <Card className="wu-task-column">{checklist}{history}</Card>
    {children}
  </div>;
}
